module.exports = __webpack_public_path__ + "c82775604d5fdec20578949a8da25bc3.svg";